angular.module('ui.order.orderItemCard.orderItemComments.newComment', [])

    .directive('newComment', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/ui/order/orderItemCard/orderItemComments/newComment/newComment.html',
            scope: {
                send: "&",
                comment: "="
            },
            controller: 'NewCommentController'
        };
    })

    .controller('NewCommentController', function ($scope, $element, $timeout, usersRepository) {
        $scope.newCommentExpand = false;
        $scope.user = null;
        $scope.getCurrentTime = function () {
            return new Date();
        };

        usersRepository.getCurrentUser().then(function (restUser) {
            $scope.user = restUser;
        });

        $scope.canSendComment = function () {
            return $scope.comment &&
                $scope.comment.text &&
                $scope.comment.text.length >= 2;
        };

        $scope.sendComment = function () {
            if ($scope.send && _.isFunction($scope.send) && $scope.canSendComment()) {
                $scope.newCommentExpand = false;
                $scope.isBusy = true;
                $scope.send();
                $scope.isBusy = false;
            }
        };

        $scope.$watch('newCommentExpand', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                $timeout(function () {
                    $element.find('#newCommentTextBox:first').focus();
                }, 0);
            }
        });
    })

;
